export function isNotNullOrUndefined<T>(input: null | undefined | T): input is T {
    return input !== null && input !== undefined;
}

export function isNotNull<T>(input: null | T): input is T {
    return input !== null;
}

export function isDefinedAndNumber(input: any): input is number {
    return isNotNullOrUndefined(input) && !isNaN(input);
}
